import { createFileRoute } from '@tanstack/react-router'
import EmployeeWallet from '@/features/employee-portal/pages/EmployeeWallet'

export const Route = createFileRoute('/_authenticated/employee-portal/wallet')({
  component: EmployeeWallet,
})

